<h2 mat-dialog-title>Confirm Autopay</h2>

<mat-dialog-content [formGroup]="form">

  <!-- Selected Account Display -->
  <div class="full-width selected-wallet" style="display: flex; align-items: center; gap: 8px;">
    <label>Selected Account:</label>

    <!-- loading state -->
    @if (loadingWallet) {
      <mat-spinner diameter="20"></mat-spinner>
    }

    <!-- Loaded and account active -->
    @if (!loadingWallet && selectedNickname) {
      <span>{{ selectedNickname }}</span>
    }

    <!-- No active account -->
    @if (!loadingWallet && !selectedNickname) {
      <span style="color: #d32f2f;">
        There is no active bank account on file. To proceed, please update your 'Bank Account' section located in Settings.
      </span>
    }
  </div>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Amount</mat-label>
    <input matInput formControlName="paymentamount" readonly>
  </mat-form-field>

  <p>Select a date</p>

  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Date</mat-label>
    <input matInput [matDatepicker]="picker" formControlName="date" [max]="maxDate" [min]="today"
      placeholder="MM/DD/YYYY">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>

      @if (form.get('date')?.hasError('maxDate')) {
        <mat-error>
          Date cannot be after the due-by ({{ maxDate | date:'MM/dd/yyyy' }})
        </mat-error>
      }
      @if (form.get('date')?.hasError('matDatepickerMin')) {
        <mat-error>
          Date cannot be in the past
        </mat-error>
      }
    </mat-form-field>

    <p>I authorize Transend to initiate a one-time electronic funds transfer from my bank listed above in the amount and
    on the date specified</p>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="onConfirm()"
      [disabled]="form.invalid || loadingWallet || !selectedNickname">
      Confirm
    </button>
  </mat-dialog-actions>